import { FormattedMessage } from 'react-intl';

import CPDashboardTabs from 'components/CPDashboardTabs';

import { CPDashboardHeaderProps } from './types';

import * as S from './styles';

const CPDashboardHeader: React.FC<CPDashboardHeaderProps> = ({
  specialistName,
  numberOfPatients,
  tabsData,
  handleChangeTab,
}) => {
  return (
    <S.HeaderContainer data-testid="CPDashboardHeaderContainer">
      <S.HeaderTitle>
        <FormattedMessage id="CARE_PROVIDER.DASHBOARD.HEADER.TITLE" />
      </S.HeaderTitle>

      {specialistName && (
        <S.HeaderWelcomeText data-testid="CPDashboardHeaderWelcomeText">
          <FormattedMessage
            id="CARE_PROVIDER.DASHBOARD.HEADER.WELCOME_TEXT"
            values={{
              specialistName,
            }}
          />
        </S.HeaderWelcomeText>
      )}

      <S.HeaderAmountInfo data-testid="CPDashboardHeaderAmountInfo">
        <FormattedMessage
          id="CARE_PROVIDER.DASHBOARD.HEADER.NUMBER_OF_PATIENTS"
          values={{
            numberOfPatients,
          }}
        />
      </S.HeaderAmountInfo>

      <CPDashboardTabs tabsData={tabsData} onTabSelected={handleChangeTab} />
    </S.HeaderContainer>
  );
};

export default CPDashboardHeader;
